import { A } from '../actions/delivery';
import update from 'immutability-helper';

const initialState = {
  findCity: {
    isFetching: false,
    error: null,
  },
  findAddress: {
    isFetching: false,
    error: null,
  },
  getPackage: {
    isFetching: false,
    error: null,
  },
  getDeliveryVariants: {
    isFetching: false,
    error: null,
  },
  getDeliveryPoints: {
    isFetching: false,
    error: null,
  },
  getPointData: {
    isFetching: false,
    error: null,
  },
  findStreet: {
    isFetching: false,
    error: null,
  },
  updateDeliveryResult: {
    isFetching: false,
    error: null,
  },
  findCompany: {
    isFetching: false,
    error: null,
  },
  findRegion: {
    isFetching: false,
    error: null,
  },
};

const delivery = (state = initialState, action) => {
  switch (action.type) {
    case A.REQUEST_FIND_CITY:
      return update(state, {
        findCity: {
          isFetching: { $set: true },
          error: { $set: null },
        },
      });

    case A.RECEIVE_FIND_CITY:
      return update(state, {
        findCity: {
          isFetching: { $set: false },
        },
      });

    case A.ERROR_FIND_CITY:
      return update(state, {
        findCity: {
          isFetching: { $set: false },
          error: { $set: action.err },
        },
      });

    case A.REQUEST_FIND_ADDRESS:
      return update(state, {
        findCity: {
          isFetching: { $set: true },
          error: { $set: null },
        },
      });

    case A.RECEIVE_FIND_ADDRESS:
      return update(state, {
        findCity: {
          isFetching: { $set: false },
        },
      });

    case A.ERROR_FIND_ADDRESS:
      return update(state, {
        findCity: {
          isFetching: { $set: false },
          error: { $set: action.err },
        },
      });

    case A.REQUEST_GET_PACKAGE:
      return update(state, {
        getPackage: {
          isFetching: { $set: true },
          error: { $set: null },
        },
      });

    case A.RECEIVE_GET_PACKAGE:
      return update(state, {
        getPackage: {
          isFetching: { $set: false },
        },
      });

    case A.ERROR_GET_PACKAGE:
      return update(state, {
        getPackage: {
          isFetching: { $set: false },
          error: { $set: action.err },
        },
      });

    case A.REQUEST_GET_DELIVERY_VARIANTS:
      return update(state, {
        getDeliveryVariants: {
          isFetching: { $set: true },
          error: { $set: null },
        },
      });

    case A.RECEIVE_GET_DELIVERY_VARIANTS:
      return update(state, {
        getDeliveryVariants: {
          isFetching: { $set: false },
        },
      });

    case A.ERROR_GET_DELIVERY_VARIANTS:
      return update(state, {
        getDeliveryVariants: {
          isFetching: { $set: false },
          error: { $set: action.err },
        },
      });

    case A.REQUEST_GET_DEVILERY_POINTS:
      return update(state, {
        getDeliveryPoints: {
          isFetching: { $set: true },
          error: { $set: null },
        },
      });

    case A.RECEIVE_GET_DEVILERY_POINTS:
      return update(state, {
        getDeliveryPoints: { isFetching: { $set: false } },
      });

    case A.ERROR_GET_DEVILERY_POINTS:
      return update(state, {
        getDeliveryPoints: {
          isFetching: { $set: false },
          error: { $set: action.err },
        },
      });

    case A.REQUEST_GET_POINT_DATA:
      return update(state, {
        getPointData: {
          isFetching: { $set: true },
          error: { $set: null },
        },
      });

    case A.RECEIVE_GET_POINT_DATA:
      return update(state, {
        getPointData: { isFetching: { $set: false } },
      });

    case A.ERROR_GET_POINT_DATA:
      return update(state, {
        getPointData: {
          isFetching: { $set: false },
          error: { $set: action.err },
        },
      });

    case A.REQUEST_FIND_STREET:
      return update(state, {
        findStreet: {
          isFetching: { $set: true },
          error: { $set: null },
        },
      });

    case A.RECEIVE_FIND_STREET:
      return update(state, {
        findStreet: {
          isFetching: { $set: false },
        },
      });

    case A.ERROR_FIND_STREET:
      return update(state, {
        findStreet: {
          isFetching: { $set: false },
          error: { $set: action.err },
        },
      });

    case A.REQUEST_UPDATE_DELIVERY_RESULT:
      return update(state, {
        updateDeliveryResult: {
          isFetching: { $set: true },
          error: { $set: null },
        },
      });

    case A.RECEIVE_UPDATE_DELIVERY_RESULT:
      return update(state, {
        updateDeliveryResult: {
          isFetching: { $set: false },
        },
      });

    case A.ERROR_UPDATE_DELIVERY_RESULT:
      return update(state, {
        updateDeliveryResult: {
          isFetching: { $set: false },
          error: { $set: action.err },
        },
      });

    case A.EQUEST_FIND_COMPANY:
      return update(state, {
        findCompany: {
          isFetching: { $set: true },
          error: { $set: null },
        },
      });

    case A.RECEIVE_FIND_COMPANY:
      return update(state, {
        findCompany: {
          isFetching: { $set: false },
        },
      });

    case A.ERROR_FIND_COMPANY:
      return update(state, {
        findCompany: {
          isFetching: { $set: false },
          error: { $set: action.err },
        },
      });

    case A.EQUEST_FIND_REGION:
      return update(state, {
        findRegion: {
          isFetching: { $set: true },
          error: { $set: null },
        },
      });

    case A.RECEIVE_FIND_REGION:
      return update(state, {
        findRegion: {
          isFetching: { $set: false },
        },
      });

    case A.ERROR_FIND_REGION:
      return update(state, {
        findRegion: {
          isFetching: { $set: false },
          error: { $set: action.err },
        },
      });

    default:
      return state;
  }
};

export default delivery;
